import type { BriefDisplayStatus, Gql } from '@fiverr-private/dynamic_matching';

export interface BriefCreatedBy {
    id: string;
    user?: { name?: string | null; fullName?: string | null } | null;
}

interface BriefItemBase {
    id: string;
    title: string;
    createdAt: number;
    createdBy: BriefCreatedBy;
    briefDisplayStatus: BriefDisplayStatus;
}

export interface DmBriefItem extends BriefItemBase {
    type: 'dm';
    hiredCount: number;
    offersCount: number;
}

export interface AgenticBriefItem extends BriefItemBase {
    type: 'agentic';
    proposalsCount: number;
}

export type BriefItem = DmBriefItem | AgenticBriefItem;

export interface BriefsList {
    totalCount: number;
    nodes: BriefItem[];
    pageInfo: Pick<Gql.PageInfo, 'endCursor' | 'hasNextPage'>;
}

export enum BriefAction {
    VIEW_BRIEF = 'VIEW_BRIEF',
    INVITE_FREELANCERS = 'INVITE_FREELANCERS',
    MANAGE_BRIEF = 'MANAGE_BRIEF',
}
